// Release configuration - update this single file when new versions are released
// Binaries hosted on public repo: https://github.com/Loxia-ai/autopilot-releases
import { brand } from './brand';

export const CURRENT_VERSION = '2.3.6';

export const RELEASE_CONFIG = {
  version: CURRENT_VERSION,
  npm: {
    package: brand.links.npmPackage,
    installCommand: `npm install -g ${brand.links.npmPackage}@${CURRENT_VERSION}`,
    icon: '/img/logo-npm.svg',
  },
  binaries: {
    windows: {
      label: 'Windows',
      filename: `${brand.name}Setup-${CURRENT_VERSION}-windows.exe`,
      url: `${brand.links.github}/releases/download/v${CURRENT_VERSION}/${brand.name}Setup-${CURRENT_VERSION}-windows.exe`,
      icon: '/img/logo-windows.svg',
    },
    mac: {
      label: 'macOS',
      filename: `${brand.name}Setup-${CURRENT_VERSION}-macos.pkg`,
      url: `${brand.links.github}/releases/download/v${CURRENT_VERSION}/${brand.name}Setup-${CURRENT_VERSION}-macos.pkg`,
      icon: '/img/logo-apple.svg',
    },
    linux: {
      label: 'Linux',
      filename: `${brand.storagePrefix}-autopilot-${CURRENT_VERSION}-amd64.deb`,
      url: `${brand.links.github}/releases/download/v${CURRENT_VERSION}/${brand.storagePrefix}-autopilot-${CURRENT_VERSION}-amd64.deb`,
      icon: '/img/logo-linux.svg',
    },
  },
  github: {
    releasesUrl: `${brand.links.github}/releases/tag/v${CURRENT_VERSION}`,
    repoUrl: brand.links.github,
  },
};

export default RELEASE_CONFIG;
